(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/base-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/base-view.js');
"use strict";

const {
  useContext,
  useEffect
} = React;
const {
  CenterToScreen
} = svs.components.tipsen.centerToScreen;
const {
  PayButton,
  OverviewButton,
  DisplayChoices,
  PayButtonExternal
} = svs.components.tipsen.betslip.views.parts;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  useIsAtBottomWindow
} = svs.components.tipsen.hooks;
const {
  useCouponId
} = svs.components.tipsen.couponId;
const {
  COUPON_SINGLEROWS,
  COUPON_EXTERNAL_SYSTEM
} = svs.components.tipsen.engine.constants.couponTypes;
const BaseView = _ref => {
  let {
    children
  } = _ref;
  const {
    isBetslipVisible,
    isExtraSmall,
    isWideDevice,
    setIsBetslipVisible,
    isAnySystemSelected,
    couponBetButtonCount
  } = useContext(BetslipContext);
  const isAtBottom = useIsAtBottomWindow();
  useEffect(() => {
    if (isAnySystemSelected || couponBetButtonCount > 0 || isAtBottom) {
      setIsBetslipVisible(true);
    } else {
      setIsBetslipVisible(false);
    }
  }, [isAnySystemSelected, isAtBottom, couponBetButtonCount, setIsBetslipVisible]);
  useEffect(() => {
    const mainContent = document.querySelector('.main-content');
    if (mainContent !== null) {
      mainContent.classList.toggle('tipsen-show', isBetslipVisible);
    }
    return () => {
      if (mainContent && mainContent.classList.contains('tipsen-show')) {
        mainContent.classList.toggle('tipsen-show', !isBetslipVisible);
      }
    };
  }, [isBetslipVisible]);
  const couponId = useCouponId();
  const isSingelRows = couponId.includes(COUPON_SINGLEROWS);
  const isExternal = couponId.includes(COUPON_EXTERNAL_SYSTEM);
  const shouldShowOverviewButton = isWideDevice && !isSingelRows && !isExternal;
  const betslipContextClass = isExtraSmall ? 'tipsen-betslip-content-xsmall' : 'tipsen-betslip-content';
  const DisplayComponent = isExternal ? PayButtonExternal : PayButton;
  return React.createElement(React.Fragment, null, isExtraSmall && React.createElement(DisplayChoices, null), React.createElement("div", {
    className: "tipsen-betslip",
    id: "tipsen-betslip"
  }, React.createElement(CenterToScreen, {
    className: betslipContextClass
  }, children, shouldShowOverviewButton && React.createElement(OverviewButton, null), React.createElement(DisplayComponent, null))));
};
setGlobal('svs.components.tipsen.betslip.views.BaseView', BaseView);

 })(window);